import { Component } from '@angular/core';
import { ProjectListComponent } from '../project-list/project-list.component';

@Component({
  selector: 'app-project-list-wrapper',
  templateUrl: './project-list-wrapper.component.html',
  styleUrls: ['./project-list-wrapper.component.scss'],
  imports: [ProjectListComponent]
})
export class ProjectListWrapperComponent {
}
